import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

const normalize = (id) => id.trim().toLowerCase();

export async function createGame(gameId, playerCount) {
  const ref = doc(db, "games", normalize(gameId));
  await setDoc(ref, {
    gameId: normalize(gameId),
    playerCount,
    drawnNumbers: [],
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function getGame(gameId) {
  const ref = doc(db, "games", normalize(gameId));
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function updateDrawnNumbers(gameId, drawnNumbers) {
  const ref = doc(db, "games", normalize(gameId));
  await updateDoc(ref, { drawnNumbers, updatedAt: serverTimestamp() });
}

export function subscribeToGame(gameId, callback) {
  const ref = doc(db, "games", normalize(gameId));
  return onSnapshot(ref, (snap) => {
    if (snap.exists()) callback(snap.data());
  });
}
